"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyMessage = void 0;
var react_1 = __importDefault(require("react"));
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css"); // Import default styles
var notifyMessage = function (msg, options) {
    (0, react_toastify_1.toast)(msg, __assign({ backgroundColor: "#f54f3b", color: "#ffffff" }, options));
};
exports.notifyMessage = notifyMessage;
var ToastMessage = function (_a) {
    var _b = _a.delay, delay = _b === void 0 ? 2000 : _b, _c = _a.position, position = _c === void 0 ? 'top-right' : _c;
    return (react_1.default.createElement(react_toastify_1.ToastContainer, { autoClose: delay, position: position, toastStyle: { background: "#f54f3b", color: "#ffffff" }, progressStyle: { background: "#ffffff" } }));
};
exports.default = ToastMessage;
